import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { FilterValueInputProps } from "../Interfaces/CustomDataGrid.interfaces";

export const CustomDataGridFilterValueField = ({
  filter,
  visibleColumns,
  handleFilterChange
}: FilterValueInputProps) => {
  const column = visibleColumns?.find(({ field }) => field === filter.field);
  const isDate = column?.type === "date";
  const isBoolean = column?.type === "boolean";
  const isNumberOperator = ["=", "!=", ">", ">=", "<", "<="].includes(filter.operator);

  if (["isEmpty", "isNotEmpty"].includes(filter.operator)) return null;

  if (isBoolean) {
    let booleanValue: string;

    if (filter.value === true) {
      booleanValue = "true";
    } else if (filter.value === false) {
      booleanValue = "false";
    } else {
      booleanValue = "any";
    }

    return (
      <FormControl size="small" sx={{ width: 200 }}>
        <InputLabel>Value</InputLabel>
        <Select
          label="Value"
          value={booleanValue}
          onChange={(e) => {
            let newValue: boolean | "" = "";
            if (e.target.value === "true") newValue = true;
            else if (e.target.value === "false") newValue = false;
            handleFilterChange(filter.id, filter.field, filter.operator, newValue);
          }}
        >
          <MenuItem value="any">any</MenuItem>
          <MenuItem value="true">true</MenuItem>
          <MenuItem value="false">false</MenuItem>
        </Select>
      </FormControl>
    );
  }

  if (isDate) {
    return (
      <TextField
        InputLabelProps={{ shrink: true }}
        label="Value"
        onChange={(e) => {
          const val = e.target.value;
          const newValue = val ? new Date(val) : "";
          handleFilterChange(filter.id, filter.field, filter.operator, newValue);
        }}
        size="small"
        sx={{ width: 200 }}
        type="date"
        value={
          filter.value && !isNaN(Date.parse(filter.value)) ? new Date(filter.value).toISOString().slice(0, 10) : ""
        }
        variant="outlined"
      />
    );
  }

  return (
    <TextField
      variant="outlined"
      size="small"
      label="Value"
      type={isNumberOperator ? "number" : "text"}
      value={filter.value}
      inputProps={isNumberOperator ? { inputMode: "numeric", pattern: "[0-9]*" } : undefined}
      onChange={(e) => {
        let newValue;
        if (isNumberOperator) {
          const val = e.target.value;
          if (val === "") newValue = "";
          else if (/^\d+$/.test(val)) newValue = Number(val);
          else newValue = filter.value;
        } else {
          newValue = e.target.value;
        }
        handleFilterChange(filter.id, filter.field, filter.operator, newValue);
      }}
      sx={{ width: 200 }}
    />
  );
};
